import firebase from "@/firebase/";
const firestore = firebase.firestore();
const auth = firebase.auth();
const users = firestore.collection("users");

// Function that get extra user data, like name and surname
// organisation. Also refreshes the token to propagate the user claims.
export const getExtraUserData = async function(uid) {
  let extraInfo = {};

  // Load user information from firestore
  let userInformationDoc = await users.doc(uid).get();
  extraInfo = { ...extraInfo, ...userInformationDoc.data() };

  // Refresh user token
  await auth.currentUser.getIdToken(true);

  // Get custom claims from id token
  let tokenResult = await auth.currentUser.getIdTokenResult();
  if (tokenResult.claims.admin) {
    extraInfo.admin = true;
  }
  if (tokenResult.claims.accessGranted) {
    extraInfo.accessGranted = true;
  }

  // Return the extra info
  return extraInfo;
};

// Functions to calculate the mean and CIs
import t_distribution_table from "./t_dist_table";

function stdev(array) {
  const n = array.length;
  const mean = array.reduce((a, b) => a + b) / n;
  const s = Math.sqrt(
    array.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / (n - 1)
  );
  return s;
}
function calcMean(array) {
  const n = array.length;
  const mean = array.reduce((a, b) => a + b) / n;
  return mean;
}
function sign(x) {
  if (isNaN(x)) {
    return NaN;
  } else if (x === 0) {
    return x;
  } else {
    return x > 0 ? 1 : -1;
  }
}
function inverseErf(x) {
  var a = 0.147;
  return (
    sign(x) *
    Math.sqrt(
      Math.sqrt(
        Math.pow(2 / (Math.PI * a) + Math.log(1 - Math.pow(x, 2)) / 2, 2) -
          Math.log(1 - Math.pow(x, 2)) / a
      ) -
        (2 / (Math.PI * a) + Math.log(1 - Math.pow(x, 2)) / 2)
    )
  );
}
function z(p) {
  if (p <= 0.0 || p >= 1.0) {
    return undefined;
  }

  return Math.sqrt(2) * inverseErf(2 * p - 1);
}

function calcConfInterval(x_bar, s, n, α, type) {
  if (
    typeof x_bar !== "number" ||
    typeof s !== "number" ||
    α <= 0.0 ||
    α >= 1.0
  ) {
    return undefined;
  }

  var σ_bar = s / Math.sqrt(n);

  // If the sample size is large, use Z Scores from the Standard Normal Distribution.
  if (n > 30) {
    // Return the upper confidence bound of a one-tailed confidence interval.
    if (typeof type !== "undefined" && type.toLowerCase() === "u") {
      return x_bar + z(1 - α) * σ_bar;
    } else {
      // Return the lower confidence bound of a one-tailed confidence interval.
      if (typeof type !== "undefined" && type.toLowerCase() === "l") {
        return x_bar - z(1 - α) * σ_bar;
      } else {
        // Return both bounds of a two-tailed confidence interval.
        return [x_bar - z(1 - α / 2) * σ_bar, x_bar + z(1 - α / 2) * σ_bar];
      }
    }
  } else {
    // Otherwise, use Student's t distribution.
    // Return the upper confidence bound of a one-tailed confidence interval.
    if (typeof type !== "undefined" && type.toLowerCase() === "u") {
      return x_bar + t_distribution_table[n - 1][1 - α] * σ_bar;
    } else {
      // Return the lower confidence bound of a one-tailed confidence interval.
      if (typeof type !== "undefined" && type.toLowerCase() === "l") {
        return x_bar - t_distribution_table[n - 1][1 - α] * σ_bar;
      } else {
        // Return both bounds of a two-tailed confidence interval.
        return [
          x_bar - t_distribution_table[n - 1][1 - α / 2] * σ_bar,
          x_bar + t_distribution_table[n - 1][1 - α / 2] * σ_bar
        ];
      }
    }
  }
}
export const confInterval = function(array) {
  const n = array.length;
  const mean = calcMean(array);
  const s = stdev(array);
  const CIs = calcConfInterval(mean, s, n, 0.05);
  return [CIs[0], mean, CIs[1]];
};
